export default __webpack_public_path__ + "static/media/calendar.f62addd9.svg";